import { useTranslation } from 'react-i18next';

import { Card, CardContent, Typography, LinearProgress, Box } from '@mui/joy';

import { getBatteryStatus, getBatteryStatusColor } from '../../general-utilities/heartbeatUtils';
import { DroneHeartBeat } from '../../models/DroneProfile/DroneProfile.model';

interface Props {
  heartbeat: DroneHeartBeat;
}

export default function BatteryStatusCard({heartbeat}: Props) {
  const { t } = useTranslation();
  const percentage = heartbeat.battery_percentage ?? 0;
  const color = getBatteryStatusColor(percentage);

  return (
    <Card color="neutral" variant="soft">
      <CardContent>
        <Typography gutterBottom level="title-md">
          {t('heartbeat.battery.title')}
        </Typography>

        <Box mt={2}>
          <Box
            sx={{
              position: 'relative',
              width: '100%',
              height: 32,
              backgroundColor: '#e5e7eb',
              borderRadius: 999,
              overflow: 'hidden'
            }}
          >
            <Box
              sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: `${percentage}%`,
                height: '100%',
                backgroundColor: color,
                borderRadius: 999
              }}
            />
            <Box
              sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <Typography fontWeight="lg" level="body-sm" textColor="white">
                {percentage}%
              </Typography>
            </Box>
          </Box>

          <Typography
            fontWeight="md"
            level="body-sm"
            mt={2}
            textAlign="center"
            textColor="neutral.700"
          >
            {getBatteryStatus(t, percentage)}
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
}